"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DISPLAY_SURFACE_TYPES = void 0;
var DISPLAY_SURFACE_TYPES = exports.DISPLAY_SURFACE_TYPES = Object.freeze({
  monitor: 'ENTIRE SCREEN',
  window: 'A WINDOW',
  browser: 'A BROWSER TAB'
});